module.exports = __webpack_public_path__ + "img/closeJob-delete.51ac046a.svg";